
import { defineComponent } from 'vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'

export default defineComponent({
  components: {
    ContentLayout
  }
})
